import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@new/lib';

interface ProgressProps extends React.ComponentProps<typeof ProgressPrimitive.Root> {
  color?: string;
}

function Progress({ className, value, color, ...props }: ProgressProps) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        'bg-(--neutral-black-NB200) relative h-3 lg:h-4.75 overflow-hidden rounded-full',
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          'h-full flex-1 transition-all rounded-xl',
          !color && 'bg-linear-to-r from-[#64D0FF] to-[#19B8FC]'
        )}
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
          ...(color && { background: color }),
        }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
